/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoiceState = {
    Unpaid: 'Unpaid',
    Voided: 'Voided',
    PaymentSent: 'PaymentSent',
    Paid: 'Paid'
} as const;
export type InvoiceState = typeof InvoiceState[keyof typeof InvoiceState];


export function instanceOfInvoiceState(value: any): boolean {
    for (const key in InvoiceState) {
        if (Object.prototype.hasOwnProperty.call(InvoiceState, key)) {
            if (InvoiceState[key as keyof typeof InvoiceState] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoiceStateFromJSON(json: any): InvoiceState {
    return InvoiceStateFromJSONTyped(json, false);
}

export function InvoiceStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceState {
    return json as InvoiceState;
}

export function InvoiceStateToJSON(value?: InvoiceState | null): any {
    return value as any;
}

export function InvoiceStateToJSONTyped(value: any, ignoreDiscriminator: boolean): InvoiceState {
    return value as InvoiceState;
}

